import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_get_billing_contract_by_idService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { billingContractId: number }): 
  Promise<{ result: { Id?: number, StatusId?: number } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.billingContractId)) {
      $missingRequiredInParams.push('\'billingContractId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      billingContractId: number    }) {
        if(isNil($inParams.billingContractId)) {
          return true; 
        }
      return false;
    }
}
